import { render, staticRenderFns } from "./reminderUser.vue?vue&type=template&id=259f4cde&scoped=true"
import script from "./reminderUser.vue?vue&type=script&lang=js"
export * from "./reminderUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f4cde",
  null
  
)

export default component.exports